module.exports = __webpack_public_path__ + "static/media/26_shape_r.c267ea68.webp";